import { DTO } from '@/type-utils';
import Model from '../../Model';
import type IOrderDigitalShippingInfo from './IOrderDigitalShippingInfo';

/**
 * Represents the shipping information for a digital (non-tangible) order.
 */
export default class OrderDigitalShippingInfoModel
  extends Model<DTO<IOrderDigitalShippingInfo>>
  implements IOrderDigitalShippingInfo
{
  /** @inheritdoc */
  public readonly email: string;
  /** @inheritdoc */
  public readonly phoneNumber: string;

  /**
   * Creates a new order digital shipping info model.
   * @param data - The data for the model.
   */
  public constructor(
    data: DTO<IOrderDigitalShippingInfo> | IOrderDigitalShippingInfo
  ) {
    super(data);

    this.email = data.email;
    this.phoneNumber = data.phoneNumber;
  }

  /** @inheritdoc */
  public override toDTO(): DTO<IOrderDigitalShippingInfo> {
    const dto: DTO<IOrderDigitalShippingInfo> = {
      email: this.email,
      phoneNumber: this.phoneNumber
    };

    return dto;
  }
}
